import React, { useState, useMemo, useEffect } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import useStore from '../../states/store';
import TabPanel from '../../components/TabPanel';
// Components
import Table from './components/Table';
import AddAreaModal from './components/AddAreaModal';
import UpdateAreaModal from './components/UpdateAreaModal';
// Context
import useAreaImprovementContext from './context/useAreaImprovementContext';
// API
import {
  getAreaListing,
  getArea,
  postArchiveArea,
  postRestoreArea,
} from '../../api/areaImprovementApi';

export default function AreaImprovementMaintenance() {
  const auth = useStore((state) => state.auth);

  const [activeTab, setActiveTab] = useState(0);
  const [loading, setLoading] = useState(false);
  const [areaData, setAreaData] = useState([]);
  const [area, setArea] = useState({});
  const [addAreaModal, setAddAreaModal] = useState({ toggle: false });
  const [updateAreaModal, setUpdateAreaModal] = useState({ toggle: false });

  const handleGenerateList = async (tab = null) => {
    try {
      setLoading(true);
      const request = {
        achived: tab ?? 0,
      };

      const response = await getAreaListing(request);
      const { code, data } = response.data;

      if (code === '200') {
        setAreaData(data);
      }
      setLoading(false);
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
    }
  };

  const handleChangeActiveTab = (event, newValue) => {
    setActiveTab(newValue);
    handleGenerateList(newValue);
  };

  const handleUpdate = async (value) => {
    try {
      const request = {
        id: value,
      };

      const response = await getArea(request);
      const { code, data } = response.data;

      if (code === '200') {
        setArea(data);
        setUpdateAreaModal({ ...updateAreaModal, toggle: true });
      }
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
    }
  };

  const hanldeArchied = async (value) => {
    try {
      const request = {
        id: value,
      };

      const { isConfirmed } = await Swal.fire({
        title: 'Approvals',
        text: `Are you sure you want to archive area for improvement?`,
        icon: 'warning',
        showCancelButton: true,
      });

      if (!isConfirmed) {
        return;
      }

      toast.loading('Processing request please kindly wait');
      const response = await postArchiveArea(request);
      const { code, message } = response.data;

      if (code === '200') {
        toast.success(message);
        handleGenerateList(activeTab);
      }
      toast.dismiss();
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
    }
  };

  const handleRestore = async (value) => {
    try {
      const request = {
        id: value,
      };

      const { isConfirmed } = await Swal.fire({
        title: 'Approvals',
        text: `Are you sure you want to restore area for improvement?`,
        icon: 'warning',
        showCancelButton: true,
      });

      if (!isConfirmed) {
        return;
      }

      toast.loading('Processing request please kindly wait');

      const response = await postRestoreArea(request);
      const { code, message } = response.data;

      if (code === '200') {
        toast.success(message);
        handleGenerateList(activeTab);
      }
      toast.dismiss();
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
    }
  };

  useEffect(() => {
    handleGenerateList();
  }, []);

  return (
    <div style={{ position: 'relative' }}>
      <useAreaImprovementContext.Provider
        value={useMemo(
          () => ({
            auth,
            activeTab,
            loading,
            areaData,
            addAreaModal,
            updateAreaModal,
            area,
            setLoading,
            setAreaData,
            setAddAreaModal,
            setUpdateAreaModal,
            handleUpdate,
            hanldeArchied,
            handleGenerateList,
            handleRestore,
          }),
          [loading, areaData, addAreaModal.toggle, updateAreaModal.toggle, area],
        )}
      >
        <Box padding={4}>
          <Box>
            <Box>
              <Grid container spacing={2}>
                <Grid xs={12} sm={12} md={12}>
                  <Box sx={{ backgroundColor: '#fff' }} mt={4}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                      <Tabs
                        value={activeTab}
                        onChange={handleChangeActiveTab}
                        aria-label='basic tabs example'
                      >
                        <Tab
                          label='List of Area for Impovement'
                          id='lising'
                          aria-controls='listing'
                        />
                        <Tab label='Archived' id='archived' aria-controls='archived' />
                      </Tabs>
                    </Box>
                    <TabPanel value={activeTab} index={activeTab}>
                      <Table />
                    </TabPanel>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
        <AddAreaModal />
        {updateAreaModal.toggle ? <UpdateAreaModal /> : ''}
      </useAreaImprovementContext.Provider>
    </div>
  );
}
